import { useState, useRef } from 'react';

export const usePdfElements = () => {
    const [elements, setElements] = useState([]);
    const [selectedElement, setSelectedElement] = useState(null);
    const elementIdCounter = useRef(0);

    const addElement = (type, x, y) => {
        const newElement = {
            id: elementIdCounter.current++,
            type,
            x: x - 50,
            y: y - 25,
            width: type === 'text' ? 200 : 150,
            height: type === 'text' ? 50 : 150,
            content: type === 'text' ? 'Texte ici' : type === 'image' ? '' : 'Chart',
            fontSize: 14,
            color: '#000000',
            opacity: 1.0,
            textAlign: type === 'text' ? 'left' : undefined,
            fontWeight: type === 'text' ? 'normal' : undefined,
            fontStyle: type === 'text' ? 'normal' : undefined,
            textDecoration: type === 'text' ? 'none' : undefined,
            mediaId: type === 'image' ? '' : undefined,
            imageSrc: type === 'image' ? '' : undefined,
            imageName: type === 'image' ? '' : undefined,
            imageMime: type === 'image' ? '' : undefined,
            queryId: type === 'chart' ? null : undefined,
            chartType: type === 'chart' ? 'bar' : undefined,
            fontScale: type === 'chart' ? 0.5 : undefined,
            backgroundColor: type === 'colorbloc' ? '#2196F3' : undefined
        };
        setElements(prev => [...prev, newElement]);
    };

    const removeElement = (id) => {
        setElements(prev => prev.filter(el => el.id !== id));
        if (selectedElement === id) setSelectedElement(null);
    };

    const updateElementContent = (id, field, value) => {
        setElements(prev => prev.map(el =>
            el.id === id ? { ...el, [field]: value } : el
        ));
    };

    const updateElementPosition = (id, x, y) => {
        setElements(prev => prev.map(el =>
            el.id === id ? { ...el, x, y } : el
        ));
    };

    const updateElementSize = (id, width, height, x, y) => {
        setElements(prev => prev.map(el =>
            el.id === id ? { ...el, width, height, x, y } : el
        ));
    };

    const bringToFront = (id) => {
        setElements(prev => {
            const index = prev.findIndex(el => el.id === id);
            if (index === -1 || index === prev.length - 1) return prev;
            const newElements = [...prev];
            const [element] = newElements.splice(index, 1);
            newElements.push(element);
            return newElements;
        });
    };

    const sendToBack = (id) => {
        setElements(prev => {
            const index = prev.findIndex(el => el.id === id);
            if (index === -1 || index === 0) return prev;
            const newElements = [...prev];
            const [element] = newElements.splice(index, 1);
            newElements.unshift(element);
            return newElements;
        });
    };

    const bringForward = (id) => {
        setElements(prev => {
            const index = prev.findIndex(el => el.id === id);
            if (index === -1 || index === prev.length - 1) return prev;
            const newElements = [...prev];
            const temp = newElements[index];
            newElements[index] = newElements[index + 1];
            newElements[index + 1] = temp;
            return newElements;
        });
    };

    const sendBackward = (id) => {
        setElements(prev => {
            const index = prev.findIndex(el => el.id === id);
            if (index === -1 || index === 0) return prev;
            const newElements = [...prev];
            const temp = newElements[index];
            newElements[index] = newElements[index - 1];
            newElements[index - 1] = temp;
            return newElements;
        });
    };

    return {
        elements,
        setElements,
        selectedElement,
        setSelectedElement,
        addElement,
        removeElement,
        updateElementContent,
        updateElementPosition,
        updateElementSize,
        bringToFront,
        sendToBack,
        bringForward,
        sendBackward
    };
};
